import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './SupplicerRetingAndName.css'
import { Link } from 'react-router-dom'

const SupplicerRetingAndName = ({supplierName, reting, ID}) => {

    return (
        <div className="supplier-name">
            <Link to={`/suppliers/${ID}`}>
                <h4>{supplierName && supplierName}</h4>
            </Link>
            <span>
                {reting &&
                    <>
                        <FontAwesomeIcon icon= {faStar} />
                        <p>{parseFloat(reting).toFixed(2)}</p>
                    </>
                }
            </span>
        </div>
    )
}

export default SupplicerRetingAndName
